import { _ep0, _mw0, command } from "../commandBuilder";
import { LoadDashboard$ } from "../schemas/schemas_0";
export class LoadDashboardCommand extends command(_ep0, _mw0, "LoadDashboard", LoadDashboard$) {
}
